import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { MenuItem } from 'src/app/layouts/sidebar/menu.model';

@Injectable({
  providedIn: 'root'
})
export class RightMenuService {

  public toggleMenu: boolean = false;
  public toggleMenuObservable: Subject<boolean> = new Subject<boolean>();
  public currentMenuItem?: MenuItem;

  constructor() { }

  public toggle(menuItem?: MenuItem) {

    this.currentMenuItem = menuItem;

    if(this.toggleMenu) {
      this.toggleMenu = !this.toggleMenu;

      document.body.classList.toggle('sidebar-enable');
      document.body.classList.toggle('vertical-collpsed');

      this.toggleMenuObservable?.next(
        this.toggleMenu
      );

      if (window.screen.width <= 768) {
        document.body.classList.remove('vertical-collpsed');
        // this.rightMenuService.toggleMenu = false;
      }
    } 
  }  
}
